// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2-p1P"};